// Boiler Plate Imports
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";
import colors from "../../theme/colors";
import { FullPageFormWrapper } from "../../components/Forms/shared";

// Conatiner Component Imports
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import ModalComponent from "../../components/Modal";

// Page Component Imports
import AdminNetworkForm from "../../components/Forms/adminNetworkForm";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmForm from "../../components/Forms/confirmForm";
import { CircularProgress } from "@mui/material";
import AdminUserForm from "../../components/Forms/adminUserForm";

const CreateUser = () => {
  const userProfile = useSelector((state) => state.user);

  const [organizationsList, setOrganizationsList] = useState([]);
  const [networksList, setNetworksList] = useState([]);

  const [saving, setSaving] = useState(false);
  const [savingError, setSavingError] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([
        dataLayer.GetAllOrganizations(),
        dataLayer.GetAllNetworks(),
      ]);
      setLoadingData(false);
    };
    loadData();
  }, []);

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Users",
          link: "/admin/users",
        },
        {
          title: "Create User",
          link: "/admin/users/create",
        },
      ])
    );
  }, []);

  const dataLayer = {
    GetAllOrganizations: async () => {
      const { organizations } = await API.Organization.OrganizationsGetAll();
      setOrganizationsList(organizations);
    },
    GetAllNetworks: async () => {
      const { networks } = await API.Network.NetworkGetAll();
      setNetworksList(networks);
    },
    CreateUser: async ({ createUserData }) => {
      return await API.User.UserCreate({ createUserData });
    },
  };

  const handlers = {
    confirmModalSubmit: () => {
      navigate(`/admin/users`);
    },
    confirmModalCancel: () => {
      setShowConfirmModal(false);
    },
    cancel: () => {
      setShowConfirmModal(true);
    },
    saveUser: async (createUserData) => {
      setSavingError("");
      setSaving(true);
      try {
        console.log("createUserData", createUserData);
        await dataLayer.CreateUser({
          createUserData,
        });

        //Create Success Notification
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "success",
            title: "Success",
            message: "User created successfully",
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
        navigate(`/admin/users`);
      } catch (err) {
        let errorMessage = err;

        setSavingError(errorMessage);

        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error Creating User",
            message: errorMessage,
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      }
      setSaving(false);
    },
  };

  return (
    <>
      
      <FullPageFormWrapper>
        <h2>
          Create User{" "}
          <span style={{ color: colors.gray }}> / Boreas Admin</span>
        </h2>
        {!loadingData ? (
          <AdminUserForm
            handleSave={handlers.saveUser}
            handleCancel={handlers.cancel}
            loading={saving}
            error={savingError}
            organizationsList={organizationsList}
            networksList={networksList}
          />
        ) : (
          <CircularProgress />
        )}
      </FullPageFormWrapper>
      <ModalComponent
        open={showConfirmModal}
        handleClose={handlers.confirmModalCancel}
        headerText={"Cancel Creating User"}
      >
        <ConfirmForm
          handleSave={handlers.confirmModalSubmit}
          handleCancel={handlers.confirmModalCancel}
          loading={false}
        >
          <div>
            <b>Are you sure you want to Cancel Creating User?</b>
            <p>You will lose all progress.</p>
          </div>
        </ConfirmForm>
      </ModalComponent>
    </>
  );
};

export default CreateUser;
